import { css } from 'linaria';
import { Variables } from '../foundation/global-styles';

export const endAdornmentSlot = css`
    background: var(--r-text-background);
    box-shadow: var(--r-text-background) -1px 0 3px 2px;
    position: absolute;
    top: 0;
    right: -2px;
    display: flex;
    gap: 8px;
    padding: 0 2px 0 4px;
`;

export const stackStyle = css`
    display: grid;
`;

export const errorIcon = css`
    color: var(--r-alert);
    path {
        fill: var(--r-alert) !important;
    }
`;

export const removeIcon = css`
    color: ${Variables.css.selectClearable};
    path {
        fill: ${Variables.css.selectClearable} !important;
    }
`;
